import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { combineReducers } from 'redux';

import StoragePaletteDetails from './Details/index';

import TransportColli from './TransportColli';
import UnpairedPalette from './UnpairedPalette';
import UnpairedPaletteAssignToExisting from './UnpairedPalette/UnpairedPaletteAssignToExisting';

import transportColliReducer from './TransportColli/store/transportColliReducer';
import unpairedPaletteReducer from './UnpairedPalette/store/unpairedPaletteReducer';
import { hasExternalSettingsAvailable } from '../sc-utilities';

export const routes = (basePath) => (
    <Switch>
        {<Route path={basePath + '/transportColli'} exact component={TransportColli} />}
        {<Route path={'/palettes/details'} exact component={StoragePaletteDetails} />}
        {hasExternalSettingsAvailable() ? <Route path={basePath + '/unpairedPalette'} component={UnpairedPalette} /> : null}
        {hasExternalSettingsAvailable() ? <Route path={basePath + '/unpairedPalette-assignToExisting'} component={UnpairedPaletteAssignToExisting} /> : null}
    </Switch>
);

export const subComponents = (translations) => [
    { name: translations["transport_collies"] || "Transport collies", path: '/transportColli', permissions: ['transport_colli'] },
];


export const reducers = combineReducers({
    transportCollies: transportColliReducer,
    unpairedPalettes: unpairedPaletteReducer
});
